import ButtonLike from './ButtonLike';

export default ButtonLike;
